import { render, staticRenderFns } from "./TrashedMessage.vue?vue&type=template&id=314c8d8e&"
import script from "./TrashedMessage.vue?vue&type=script&lang=js&"
export * from "./TrashedMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports